module.exports = __webpack_public_path__ + "static/media/similar-2.b2d7f3b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/similar-2.jpg
// module id = 555
// module chunks = 0